import React, { useEffect, useRef, useState } from "react";

interface Skill {
  id: number;
  name: string;
  level: number;
}

export const Skills = () => {
  const [skills] = useState<Skill[]>([
    {
      id: 1,
      name: "PHP",
      level: 30,
    },
    {
      id: 2,
      name: "ReactJs",
      level: 75,
    },
    {
      id: 3,
      name: "React Native",
      level: 70,
    },
    {
      id: 4,
      name: "Laravel",
      level: 40,
    },
    {
      id: 5,
      name: "Vue.js",
      level: 55,
    },
    {
      id: 6,
      name: "HTML",
      level: 95,
    },
    {
      id: 7,
      name: "CSS",
      level: 95,
    },
    {
      id: 8,
      name: "JavaScript",
      level: 80,
    },
  ]);

  return (
    <div className="tw-h-screen tw-flex tw-flex-col tw-items-center tw-justify-center">
      <div className=" lg:tw-max-w-[40%] tw-flex tw-flex-col tw-items-center tw-justify-center lg:tw-items-start lg:tw-justify-start">
        <p className="tw-font-bold tw-text-5xl tw-text-white ">Minhas Skills</p>
        <div className="tw-flex tw-flex-wrap tw-py-3">
          <span className=" tw-text-white tw-text-center">
            Essas são minhas habilidades de acordo <br />
            com os frameworks que uso.
          </span>
        </div>
      </div>
      <div className="tw-w-4/5 tw-grid tw-grid-cols-2 tw-gap-4">
        {skills.map((item) => (
          <div className="tw-mb-6" key={item.id}>
            <span className="tw-text-white tw-font-bold">{item.name}</span>
            <div className="tw-w-full tw-h-6 tw-mt-2 tw-bg-[#1D1D1D]">
              <div
                className={`tw-h-full tw-transition-all tw-duration-300 ${
                  item.level > 0 && "tw-bg-[#294D97]"
                }`}
                style={{ width: `${Math.abs(item.level)}%` }}
              >
                <span className="tw-font-bold tw-text-sm tw-px-1 tw-text-white">{item.level}%</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
